<template>
  <div id="services" class="mt-2 mb-8">
    <Header />
    <div class="container_width">
      <div class="d-block py-4 mb-4 sansation_title pg_title_color footer_black--text">Services</div>
      <div class="mb-10">
        <div class="sansation_subtitle pg_subtitle_color font-weight-medium">What&apos;s next?</div>
        <div class="my-3" >Finished up a project and looking for the next step to grow, exit or improve your business? Our<br/>
            member portal is here to help you through all stages of your business. To request access to another<br/>
            module, contact us at <a href="mailto:info@successionresourcegroup.com" target="_blank">info@successionresourcegroup.com</a>
        </div>
      </div>
      <div class="mb-10">
        <ServiceCards />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
import Cookie from "js-cookie";
  import appUrls from '../helpers/environment';
  
  import Header from './Header'
  import ServiceCards from './ServiceCards'
  
  export default {
      name: 'Services',
      components: {
        Header,
        ServiceCards
      },

      created () {
        	document.title = 'SRG myCompass: Services'
    	},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #services {
    min-height: 60vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Services.vue